import {
  LIST_REPORTS_SUCCESS,
  LIST_REPORTS_FAILED,
  SET_ALERT_FOR_REPORTS,
  LIST_REPORTS_DAMAGE_SUCCESS,
  LIST_REPORTS_DAMAGE_FAILED,
  LIST_REPORTS_DAMAGE_IMAGE_SUCCESS,
  LIST_REPORTS_DAMAGE_IMAGE_FAILED,
  DOWNLOAD_LOADING_REPORT,
  GENERATING_LOADING_REPORT,
  GENERATING_STATUS_MESSAGE,
  LOADING_DATA_REPORT,
  LIST_REPORT_FILES,
  LIST_REPORT_FILES_LOADING,
  LOADING_DATA_REPORT_UPLOAD,
  LOADING_BASE_LAYER,
  LOADING_ANNOTATION_LAYER,
  LOADING_ASSET_LAYER,
  BASE_ANNOTATION_DATA,
  BASE_ASSET_DATA,
  BASE_LAYER_DATA,
  RESET_REPORTS,
  LIST_SEGMENTED_DATA_LOADING,
  LIST_SEGMENTED_DATA,
} from "../actions/types";
const initialState = {
  loading: false,
  isError: false,
  isErrorType: null,
  errMessage: null,
  data: [],
  damage: [],
  severity: [],
  ReportSeverities: [],
  isAlert: false,
  alertType: false,
  alertMessage: null,
  damageData: [],
  damageImages: [],
  downloadLoading: false,
  reportsFileList: [],
  reportsFileListLoading: false,
  reportFilesUploading: false,
  baseLayer: [],
  baseLayerLoading: true,
  assetLayer: [],
  assetLayerMetaData: [],
  assetLayerLoading: true,
  annotationLayer: [],
  annotationLayerMetaData: [],
  annotationLayerLoading: false,
  generatingLoading: false,
  generatingStatusMessage: null,
  segmentedData: [],
  segmentedDataLoading: true,
};

function companyReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case RESET_REPORTS:
      return {
        loading: false,
        isError: false,
        isErrorType: null,
        errMessage: null,
        data: [],
        damage: [],
        severity: [],
        isAlert: false,
        alertType: false,
        alertMessage: null,
        damageData: [],
        damageImages: [],
        downloadLoading: false,
        reportsFileList: [],
        reportsFileListLoading: false,
        reportFilesUploading: false,
        baseLayer: [],
        baseLayerLoading: true,
        assetLayer: [],
        assetLayerMetaData: [],
        assetLayerTypeMeta: [],
        assetLayerLoading: true,
        annotationLayer: [],
        annotationLayerMetaData: [],
        annotationLayerTypeMeta: [],
        annotationLayerLoading: false,
        generatingLoading: false,
        generatingStatusMessage: null,
        segmentedData: [],
        segmentedDataLoading: true,
      };
    case LIST_SEGMENTED_DATA_LOADING:
      return {
        ...state,
        segmentedDataLoading: payload,
      };
    case LIST_SEGMENTED_DATA:
      return {
        ...state,
        segmentedData: payload,
      };
    case LOADING_DATA_REPORT_UPLOAD:
      return {
        ...state,
        reportFilesUploading: payload,
      };
    case LOADING_BASE_LAYER:
      return {
        ...state,
        baseLayerLoading: payload,
      };
    case LOADING_ASSET_LAYER:
      return {
        ...state,
        assetLayerLoading: payload,
      };
    case LOADING_ANNOTATION_LAYER:
      return {
        ...state,
        annotationLayerLoading: payload,
      };
    case BASE_LAYER_DATA:
      return {
        ...state,
        baseLayer: payload,
      };
    case BASE_ASSET_DATA:
      return {
        ...state,
        assetLayer: payload.data,
        assetLayerMetaData: payload.meta,
        assetLayerTypeMeta: payload.type_meta,
      };
    case BASE_ANNOTATION_DATA:
      return {
        ...state,
        annotationLayer: payload.data,
        annotationLayerMetaData: payload.meta,
        annotationLayerTypeMeta: payload.type_meta,
      };
    case LIST_REPORT_FILES:
      return {
        ...state,
        reportsFileList: payload.data,
        ReportSeverities: payload.report_severities,
        reportsFileListLoading: false,
      };
    case LIST_REPORT_FILES_LOADING:
      return {
        ...state,
        reportsFileListLoading: payload,
      };
    case LOADING_DATA_REPORT:
      return {
        ...state,
        loading: payload,
      };
    case GENERATING_LOADING_REPORT:
      return {
        ...state,
        generatingLoading: payload,
      };
    case GENERATING_STATUS_MESSAGE:
      return {
        ...state,
        generatingStatusMessage: payload,
      };
    case DOWNLOAD_LOADING_REPORT:
      return {
        ...state,
        downloadLoading: payload,
      };
    case SET_ALERT_FOR_REPORTS:
      return {
        ...state,
        isAlert: payload.isAlert,
        alertType: payload.isAlertError,
        alertMessage: payload.alertMessage,
      };
    case LIST_REPORTS_DAMAGE_SUCCESS:
      return {
        ...state,
        damageData: payload.data,
      };
    case LIST_REPORTS_DAMAGE_FAILED:
      return {
        ...state,
        damageData: [],
      };
    case LIST_REPORTS_DAMAGE_IMAGE_SUCCESS:
      return {
        ...state,
        damageImages: payload.data,
      };
    case LIST_REPORTS_DAMAGE_IMAGE_FAILED:
      return {
        ...state,
        damageImages: [],
      };
    case LIST_REPORTS_SUCCESS:
      return {
        ...state,
        data: payload.data,
        damage: payload.damage,
        severity: payload.severity,
      };
    case LIST_REPORTS_FAILED:
      return {
        ...state,
        data: [],
        damage: [],
        severity: [],
        loading: false,
      };
    default:
      return state;
  }
}

export default companyReducer;
